// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('product.departments.new', {
        url: '/new',
        views: {
            "productView@product": {
                templateUrl: 'main/product/departments/department/department.tpl.html',
                controller: 'DepartmentController as vm'
            }
        },
        resolve: {
            department: function () { return {}; },
            mainGroups: mainGroupsResolver,
            createNew: function () { return true; }
        }
    });

    $stateProvider.state('product.departments.department', {
        url: '/{departmentId}',
        views: {
            "productView@product": {
                templateUrl: 'main/product/departments/department/department.tpl.html',
                controller: 'DepartmentController as vm'
            }
        },
        resolve: {
            department: departmentsResolver,
            mainGroups: mainGroupsResolver,
            createNew: function () { return false; }
        }
    });
}


// @ngInject
function departmentsResolver($stateParams, DepartmentsApiService) {
    return DepartmentsApiService.getDepartment($stateParams.departmentId);
}

// @ngInject
function mainGroupsResolver(DepartmentsApiService) {
    return DepartmentsApiService.getMainGroups();
}

// @ngInject
function DepartmentController($state, department, mainGroups, loadSpinnerService, createNew, DepartmentsApiService, $scope, $translate, ToasterService) {
    var vm = this;

    //properties
    vm.department = department;
    vm.isNew = false;
    vm.isEditing = false;
    vm.mainGroups = mainGroups;
    vm.departmentCopy = {};
    vm.devFeaturesEnabled = localStorage.getItem('devFeature_reactDepartmentView') === 'true';
    vm.reactDepartmentId = createNew ? null : (department && department.id != null ? department.id : null);

    //functions
    vm.enableEditing = enableEditing;
    vm.cancelEditing = cancelEditing;
    vm.save = save;

    //initialize
    if (createNew) {
        vm.department = { mainGroup: {} };
        vm.department.mainGroup = angular.copy(vm.mainGroups[0]);
        vm.isNew = true;
        vm.isEditing = true;

    }

    function enableEditing() {
        vm.isEditing = true;
        vm.departmentCopy = angular.copy(vm.department);
    }

    function cancelEditing() {
        vm.isEditing = false;
        vm.department = vm.departmentCopy;
    }

    function save() {

        DepartmentsApiService.save(vm.department).then(function (result) {
            vm.department.id = result.id;
            vm.isEditing = false;
            vm.isNew = false;
            ToasterService.showSuccess('"' + vm.department.departmentCode + '" ' + $translate.instant("common.wasSaved"), $translate.instant("article.department"));

        }, function (error) {
            ToasterService.showError(error.message, $translate.instant("article.department"));
        }).finally(function () {
            $state.go('product.departments.department', { subCategoryId: vm.department.id });
        });
    }
}

angular
    .module('departments.department', [])
    .config(stateConfig)
    .controller('DepartmentController', DepartmentController);
